import { Injectable } from '@angular/core';
import { STContactDashService } from 'scaletech-core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class STContactDataService extends STContactDashService {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
